window._define('widgets/formEvents', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';
    var widgetName = 'formEvents',
        selectorClass = 'js-formEvents';

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        options: {
            formName: null,
        },

        _create: function () {
            this._super(selectorClass);
            this._isfillStartedEventFired = false;
            this._isDirty = false;

            this._attachEvents();
        },

        _getFormName: function () {
            return this.options.formName || this.element.attr('id');
        },

        _attachEvents: function () {
            this._on(this.element, {
                'keydown input[type=text]': this._onChangeSomething,
                'keydown input[type=email]': this._onChangeSomething,
                'keydown textarea': this._onChangeSomething,
                'change select': this._onChangeSomething,
                'change input[type=radio]': this._onChangeSomething,
                'change input[type=checkbox]': this._onChangeSomething,
            });
        },

        _onChangeSomething: function (event) {
            this._isDirty = true;

            if (!this._isfillStartedEventFired) {
                this._trigger('onFillStarted', event, { formName: this._getFormName() });
                this._isfillStartedEventFired = true;
            }
        },

        isDirty: function () {
            return this._isDirty;
        },
    });

    $('.' + selectorClass)[widgetName]();

    return $.OC[widgetName];
});
